(() => {
  const CUTOFF_HOUR = 15; // 3pm

  function formatDate(date) {
    return date.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  }

  function addDispatchDays(date, days) {
    const d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) days--; // skip Sunday
    }
    return d;
  }

  function nextCutoff(now) {
    const d = new Date(now);
    const cutoff = new Date(d);
    cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);

    // Sunday or after cutoff → next dispatch day
    if (d.getDay() === 0 || d > cutoff) {
      do {
        cutoff.setDate(cutoff.getDate() + 1);
      } while (cutoff.getDay() === 0);
    }

    return cutoff;
  }

  function render(box) {
    const target = box.querySelector(".wt-delivery-estimate__primary-text");
    if (!target) return;

    const now = new Date();
    const cutoff = nextCutoff(now);
    const deliveryBy = addDispatchDays(cutoff, 2);

    const icons = [
      '<path d="M6 7h12l1 14H5L6 7Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
      '<path d="M3 5h11v12H3zM14 10h4l3 4v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
      '<path d="m3 11 9-8 9 8M5 10v11h14V10M9 21v-7h6v7"/>'
    ];
    const labels = ['Order Today', 'Shipped', 'Delivered to you'];
    const dates = [now, cutoff, deliveryBy];
    target.innerHTML = '<span class="gv-delivery-timeline">' + labels.map((label, i) =>
      '<span class="gv-delivery-step"><span class="gv-delivery-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + icons[i] + '</svg></span><strong>' + label + '</strong><span class="gv-delivery-date">' + formatDate(dates[i]) + '</span></span>'
    ).join('') + '</span><span class="gv-delivery-note">Estimated UK dispatch and delivery</span>';
    box.classList.add('gv-delivery-timeline-ready');
  }

  function init() {
    if (!document.getElementById('gv-delivery-timeline-styles')) {
      const style = document.createElement('style');
      style.id = 'gv-delivery-timeline-styles';
      style.textContent = `
        .gv-delivery-timeline-ready .wt-delivery-estimate__primary{display:block!important;width:100%;padding-bottom:12px;margin-bottom:6px;border-bottom:1px solid #dce1dd}
        .gv-delivery-timeline-ready .wt-delivery-estimate__primary>.wt-bullet-img{display:none!important}
        .gv-delivery-timeline-ready .wt-delivery-estimate__primary-text{display:block;width:100%}
        .gv-delivery-timeline{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));width:100%;gap:0;padding:5px 0}
        .gv-delivery-step{position:relative;display:flex;flex-direction:column;align-items:center;text-align:center;gap:5px;min-width:0}
        .gv-delivery-step:not(:last-child):after{content:'';position:absolute;top:20px;left:calc(50% + 24px);width:calc(100% - 48px);border-top:2px dotted #8a9c90}
        .gv-delivery-icon{display:grid;place-items:center;width:40px;height:40px;border-radius:50%;background:#e2e9e3;color:#173a2b}
        .gv-delivery-icon svg{width:23px;height:23px}
        .gv-delivery-step strong{font-size:12px;line-height:1.25;font-weight:600}
        .gv-delivery-date{font-size:11px;line-height:1.35;color:#536059}
        .gv-delivery-note{display:block;text-align:center;font-size:10px;color:#69736d;margin-top:6px}
        @media(max-width:360px){.gv-delivery-step strong{font-size:11px}.gv-delivery-date{font-size:10px}}
      `;
      document.head.appendChild(style);
    }
    document.querySelectorAll('.wt-delivery-estimate').forEach(render);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
